import { ArrowLeftOutlined } from '@ant-design/icons';
import { history, useIntl } from '@umijs/max';
import { Button } from 'antd';
import React from 'react';
import { useRoleHomePath } from '@/hooks';

/**
 * Prominent "back to workspace" button for pages without the workspace
 * sidebar (the /account pages). Navigates to a deterministic role-aware home
 * instead of relying on browser history, which breaks on direct entry.
 */
const BackToWorkspaceButton: React.FC = () => {
  const intl = useIntl();
  const homePath = useRoleHomePath();
  const isAdminHome = homePath.startsWith('/admin');

  return (
    <Button icon={<ArrowLeftOutlined />} onClick={() => history.push(homePath)}>
      {isAdminHome
        ? intl.formatMessage({
            id: 'component.backToWorkspace.admin',
            defaultMessage: 'Back to Admin',
          })
        : intl.formatMessage({
            id: 'component.backToWorkspace.merchants',
            defaultMessage: 'Back to Merchant List',
          })}
    </Button>
  );
};

export default BackToWorkspaceButton;
